import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { useReturnRequests } from "@babackapp/return-widget-components/queries/use-return-requests";
import { useReturnableItems } from "@babackapp/return-widget-components/hooks/use-returnable-items";
import { PackageX } from "lucide-react";
import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { useWidgetParams } from "../../hooks/use-widget-params";

export function CancelComplete() {
  const { orderId, shopSlug, isRetractionPortal } = useWidgetParams();
  const t = useCustomText();
  const { data: returnRequestsData } = useReturnRequests({ orderId, shopSlug });
  const returnableItems = useReturnableItems(orderId, shopSlug);

  const hasOtherRequests = (returnRequestsData?.returnRequests.length ?? 0) > 0;
  const hasReturnableItems = returnableItems.length > 0;

  return (
    <WidgetPage variant="centered">
      <motion.span
        initial={{ opacity: 0, scale: 0.9, y: 5, rotate: -10 }}
        animate={{ opacity: 1, scale: 1, rotate: 0, y: 0 }}
        exit={{ opacity: 0, y: 20, transition: { duration: 0.25, ease: "easeIn" } }}
        transition={{ delay: 0.2, type: "spring" }}
        style={{ transformOrigin: "top left" }}
      >
        <PackageX className="text-muted-foreground size-10 mx-auto" />
      </motion.span>

      <Header>
        <HeaderTitle>{t("returnRequests.cancelled.title")}</HeaderTitle>
        <HeaderDescription>
          {t("returnRequests.cancelled.description")}
        </HeaderDescription>
      </Header>

      <AnimatedButtonRow variants={{}}>
        {hasOtherRequests && (
          <AnimatedButtonContainer layoutId="cancel-view-requests-button" variants={{}}>
            <Link to="..">
              <Button variant="secondary">
                {t("returnRequests.cancelled.viewRequests")}
              </Button>
            </Link>
          </AnimatedButtonContainer>
        )}
        {hasReturnableItems && (
          <AnimatedButtonContainer layoutId="cancel-new-return-button" variants={{}}>
            <Link to={isRetractionPortal ? "../../retractation-article-selection" : "../../line-item"}>
              <Button>
                {t("returnRequests.cancelled.newReturn")}
              </Button>
            </Link>
          </AnimatedButtonContainer>
        )}
      </AnimatedButtonRow>
    </WidgetPage>
  );
}
